module.exports = __webpack_public_path__ + "img/banner.3379b1cb.png";